export default "__VITE_PUBLIC_ASSET__b2cd4eb3__"